module.exports = __webpack_public_path__ + "static/media/headerCommandsMobile_old.71b3afea.svg";